import { WindowSizeService } from "../../../services/window-size.service"
import { Component, Input, OnInit } from "@angular/core"
import { ResourceService } from "../../../services/resource.service"
import { AddOnViewService } from "../../../services/add-on-view.service"
import { Resource } from "../../../models/resource/resource"
import { routeAnimations, routeTransition } from "../../../utils/animations"

@Component({
    selector: "app-media-gallery-resource",
    templateUrl: "./media-gallery-resource.component.html",
    styleUrls: ["./media-gallery-resource.component.scss"],
    host: { "[@routeTransition]": "true", "[@routeAnimations]": "false", style: "display: block;" },
    animations: [routeTransition, routeAnimations],
    standalone: false,
})
export class MediaGalleryResourceComponent implements OnInit {
    @Input() resource: Resource
    isAddonView: boolean

    constructor(
        public resourceService: ResourceService,
        public windowSize: WindowSizeService,
        public addOnService: AddOnViewService
    ) {}

    ngOnInit() {
        this.isAddonView = this.addOnService.isAddonView
    }
}
